/// <reference path="../services.module.ts" />
/// <reference path="../../../../../typings/index.d.ts" />

module Meevo.Plugins.Services {

    class CompensationEmployeesModalController {


        static $inject = ["title", "employees", "$mdDialog", "$mdToast", "model", "compensationType","isReadonly"];
        public employees: any;
        public title: any;
        public empCriteria:any;
        public model: Model.ServiceCompensation;
        public compensationType: any;
        public atLocationId: any;
        private isReadonly:boolean;
        constructor(title: any, employees: any, private $mdDialog: ng.material.IDialogService, private $mdToast: angular.material.IToastService, model: any, compensationType:any, isReadonly:boolean) {

            this.title = title;
            this.employees = employees;
            this.model = model;
            this.compensationType = compensationType;
            this.atLocationId = this.model.locationId;
            this.isReadonly = isReadonly;
        }

        apply = (arr: any) => {

            this.$mdDialog.hide();
        }

        public addRowOverride(): void {
            let overridesRowModel: Model.EmployeeServoceOverride = {
                employeeId: "",
                displayName: "",
                isPercent: true,
                compensationAmount: 0,
                serviceCommissionAdjustmentType: this.compensationType,
                serviceId: this.model.id
                
            };
          
            if (this.model.employeeOverrideListShopCosts == undefined)
                this.model.employeeOverrideListShopCosts = [];
            if (this.model.employeeOverrideListLaborCosts == undefined)
                this.model.employeeOverrideListLaborCosts = [];
            if (this.model.employeeOverrideListFirstTime == undefined)
                this.model.employeeOverrideListFirstTime = [];
            if (this.model.employeeOverrideListCommissionOverride == undefined)
                this.model.employeeOverrideListCommissionOverride = [];
            switch (this.compensationType) {
                case '30041':
                    this.model.employeeOverrideListShopCosts.push(overridesRowModel);
                    this.employees = this.model.employeeOverrideListShopCosts;
                    break;
                case '30042':
                    this.model.employeeOverrideListLaborCosts.push(overridesRowModel);
                    this.employees = this.model.employeeOverrideListLaborCosts;
                    break;
               case '30043':
                    this.model.employeeOverrideListFirstTime.push(overridesRowModel);
                   this.employees = this.model.employeeOverrideListFirstTime;
                   break;
               case '30044':
                    this.model.employeeOverrideListCommissionOverride.push(overridesRowModel);
                    this.employees = this.model.employeeOverrideListCommissionOverride;
                    break;
            }
            
        }

        /**
      * Click remove icon
      * Remove item from Discounts
      * @param item - item row override for delete
      * @param arr - list items
      * */
        public removeRow(item: Model.EmployeeServoceOverride): void {
            let index = this.employees.indexOf(item);
           if (this.model.deletedEmployeeOverrideList == undefined) {
                this.model.deletedEmployeeOverrideList = [];
            }
            if(item.employeeId.length > 0)
            this.model.deletedEmployeeOverrideList.push(item);
           
           
            this.employees.splice(index, 1);
        }

        /**
         * Select item for override
         * @param item - item for override
         */
        public changeOverrideItem(item: Model.EmployeeServoceOverride): void {
            if (item.overrideModel.id) {
                item.employeeId = item.overrideModel.id;
                item.displayName = item.overrideModel.displayName;
            }
        }

        get getEmpServiceCriteria(): any {
         
            var excludeListIds: any = [];
            _.forEach(this.employees, function (item: Model.EmployeeServoceOverride) {
                if(item.employeeId != "")
                excludeListIds.push(item.employeeId);
            });
           
            return  excludeListIds ;
        }

        close = () => {
            this.$mdDialog.hide();
        }

    }
    angular.module("meevo.plugins.services")
        .controller("meevo.plugins.services.CompensationEmployeesModalController", CompensationEmployeesModalController);
}